import Ajax from "@/lib/ajax";
export default {
  /**
   * 创建积分商品
   * @param data
   */
  addRewardPointProduct(data: any) {
    return Ajax.post(`/api/MarketingManagement/RewardPointProduct`, data);
  },
  /**
   * 获取积分商品详情
   * @param id
   */
  getRewardPointProduct(id: string) {
    return Ajax.get(`/api/MarketingManagement/RewardPointProduct/${id}`);
  },
  /**
   * 更新积分商品详情
   * @param id
   * @param data
   */
  updateRewardPointProduct(id: string, data: any) {
    return Ajax.put(`/api/MarketingManagement/RewardPointProduct/${id}`, data);
  },
  getList(pageSize: number, currentPage: number, keyWord?: string, productType?: number, published?: boolean) {
    let params = {
      KeyWord: keyWord,
      ProductType: productType,
      Published: published,
      MaxResultCount: pageSize,
      SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
    };

    return Ajax.get("/api/MarketingManagement/RewardPointProduct", {
      params: params
    });
  },
  updatePublished(ids: string[], state: boolean) {
    let data = {
      ids: ids,
      published: state
    }
    return Ajax.put(`/api/MarketingManagement/RewardPointProduct/published`, data);
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/MarketingManagement/RewardPointProduct/${id}`);
  }
};
